import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - LIST ITEM BUTTON ||============================== //

export default function ListItemButton(theme: Theme) {
  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: theme.vars!.palette.primary.main,
            '& .MuiListItemIcon-root': {
              color: theme.vars!.palette.primary.main
            }
          }
        }
      }
    }
  };
}
